type LpfState = { y: number | null; s: number | null };

export class OneEuroFilter {
  freq: number;
  minCutOff: number;
  beta: number;
  dCutOff: number;
  _x: LpfState;
  _dx: LpfState;
  _lt: number | null;

  constructor(freq: number = 60, minCutOff: number = 1.0, beta: number = 0.0, dCutOff: number = 1.0) {
    this.freq = freq; this.minCutOff = minCutOff; this.beta = beta; this.dCutOff = dCutOff;
    this._x = { y: null, s: null }; this._dx = { y: null, s: null }; this._lt = null;
  }
  _alpha(c: number): number { const te = 1/this.freq, tau = 1/(2*Math.PI*c); return 1/(1+tau/te); }
  _lpf(st: LpfState, v: number, a: number): number { const s = st.s === null ? v : a*v + (1-a)*st.s; st.y = v; st.s = s; return s; }
  filter(x: number, t: number | null = null): number {
    if (this._lt !== null && t !== null) { const dt = t - this._lt; if (dt > 0) this.freq = 1/dt; }
    this._lt = t;
    const dx = this._x.y === null ? 0 : (x - this._x.y) * this.freq;
    const edx = this._lpf(this._dx, dx, this._alpha(this.dCutOff));
    return this._lpf(this._x, x, this._alpha(this.minCutOff + this.beta * Math.abs(edx)));
  }
  reset(): void { this._x = { y: null, s: null }; this._dx = { y: null, s: null }; this._lt = null; }
}
